import { Tooltip } from "antd";

const TooltipWrapper = ({ title = "Sample title", body = <></> }) => {
  return <Tooltip title={title}>{body}</Tooltip>;
};

export default TooltipWrapper;
